JST["frame-size-label"] = function anonymous(it
) {
var out='<span class="frame-size-label-wrapper"> <span class="frame-size-label">'+( it.frameSize)+'</span> <span class="frame-size-in-mm">'+( it.frameWidth)+'</span></span>';return out;
};